/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  travelApplicant: 'travelApplicant',
  travelParticipants: 'travelParticipants',
  transfer: 'transfer',
  transferIncluded: 'transferIncluded',
  insurance: 'insurance',
  insuranceIncluded: 'insuranceIncluded',
  totalPrice: 'totalPrice',
  ADULT: 'ADULT',
  CHILD: 'CHILD',
  INFANT: 'INFANT'
}; export default Keys;